const Constant = {
   //serverlink: 'http://localhost:7133',
    serverlink: 'https://api.mineldayaa.com',
    timeout: 40000
};

export default Constant;